export const FETCH_ALL_SHIFTS = 'api/FETCH_ALL_SHIFTS'
export const FETCH_ALL_SHIFTS_SUCCESS = 'api/FETCH_ALL_SHIFTS_SUCCESS'
export const FETCH_ALL_SHIFTS_FAILED = 'api/FETCH_ALL_SHIFTS_FAILED'
